import React from 'react';
import {MT7_REGISTRATION_CONTEST} from "../../../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import {useMutation} from "@apollo/client";
import "./MutationRegistrationContest.css";
import waitingGif from "../../../../../static/img/waiting.gif";

function MutationRegistrationContest (props) {
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    const [MT7RegistrationContest, { loading, error }] = useMutation(MT7_REGISTRATION_CONTEST);
    //console.log('MutationRegistrationContest',props.PrerenderTexts);
    if (loading) return <div className='MutationRegistrationContestLoading'><img src={waitingGif} alt='Ifyoudontseeimages' width='27px' height='27px' /><TextSource ArrIndex= 'ContestRegistration0070'>Идет регистрация аккаунта</TextSource></div>;

    if (error) {return (<div>
        <p>Error: ${error.message}</p>;
        <div className='ButtonFXBitcoinContestRegistration' role = "button" tabIndex={0} onKeyPress={() => {}}
        onClick={async event => {event.preventDefault(); if (props.CheckAllForm())
    { await MT7RegistrationContest({ variables: { email : props.Email, password : props.Password, TradingAccount : +props.TradingAccount, ContestName: props.ContestName } })
        .then(async ({ data }) => {
            props.DoRegistration(data);
        })}}}
        ><TextSource ArrIndex= 'ContestRegistration0075'>Принять участие в конкурсе</TextSource></div>
    </div>);
    }
    return (
                    <div className='ButtonFXBitcoinContestRegistration' role = "button" tabIndex={0} onKeyPress={() => {}}
                         onClick={async event => {event.preventDefault(); if (props.CheckAllForm())
                         { await MT7RegistrationContest({ variables: { email : props.Email, password : props.Password, TradingAccount : +props.TradingAccount, ContestName: props.ContestName } })
                             .then(async ({ data }) => {
                                 props.DoRegistration(data);
                             })}}}
                    ><TextSource ArrIndex= 'ContestRegistration0075'>Принять участие в конкурсе</TextSource></div>
    )}
export default MutationRegistrationContest